<template>
  <section class="section-block">
    <div class="container">
      <section-title
        kicker="Liên hệ"
        title="Đăng ký tư vấn giải pháp nước"
        description="Để lại thông tin, đội ngũ kỹ thuật sẽ phản hồi sớm với phương án phù hợp."
      />
      <div class="row">
        <div class="col-lg-7 mb-4 mb-lg-0">
          <div class="section-card p-4 p-lg-5">
            <b-form @submit.prevent="handleSubmit">
              <b-form-group label="Họ tên">
                <b-form-input v-model.trim="form.fullName" required />
              </b-form-group>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group label="Số điện thoại">
                    <b-form-input v-model.trim="form.phone" required />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Email">
                    <b-form-input v-model.trim="form.email" type="email" required />
                  </b-form-group>
                </div>
              </div>
              <b-form-group label="Nội dung cần tư vấn">
                <b-form-textarea v-model.trim="form.message" rows="6" required />
              </b-form-group>
              <b-button type="submit" variant="primary" pill class="px-4" :disabled="loading">
                {{ loading ? "Đang gửi..." : "Gửi yêu cầu" }}
              </b-button>
            </b-form>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="section-card p-4 p-lg-5 h-100">
            <h4 class="font-weight-bold text-primary mb-4">Thông tin liên hệ</h4>
            <div class="mb-3"><strong>Địa chỉ:</strong> {{ companyInfo.address }}</div>
            <div class="mb-3"><strong>Điện thoại:</strong> {{ companyInfo.phone }}</div>
            <div class="mb-3"><strong>Email:</strong> {{ companyInfo.email }}</div>
            <div class="mb-3"><strong>Website:</strong> {{ companyInfo.website }}</div>
            <div class="alert alert-info mb-0">
              Chúng tôi sẽ phản hồi sớm nhất sau khi nhận được yêu cầu.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { submitContact } from "../../api/public";
import SectionTitle from "../../components/SectionTitle.vue";

function defaultForm() {
  return {
    fullName: "",
    phone: "",
    email: "",
    message: ""
  };
}

export default {
  name: "ContactView",
  components: {
    SectionTitle
  },
  props: {
    companyInfo: {
      type: Object,
      default: function defaultCompanyInfo() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      form: defaultForm()
    };
  },
  methods: {
    async handleSubmit() {
      this.loading = true;

      try {
        const response = await submitContact(this.form);
        this.$bvToast.toast(response.data.message, {
          variant: "success",
          solid: true
        });
        this.form = defaultForm();
      } catch (error) {
        this.$bvToast.toast(
          (error.response && error.response.data && error.response.data.message) ||
            "Không thể gửi yêu cầu.",
          {
            variant: "danger",
            solid: true
          }
        );
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

